<p-toast position="top-right" styleClass="app-toast" >
      <ng-template let-message pTemplate="message">

        <div class="flex items-start gap-4 pr-2 flex-1">

          <!-- External SVG Icon -->

          <app-icon [name]="getIcon(message.severity)"/>

          <!-- Content -->
          <div>
            <div class="text-sm text-primary">
              {{ message.detail }}
            </div>
          </div>
        </div>

      </ng-template>
    </p-toast>
